exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".visa-icon .cls-1 {\n  fill:#1565c0;\n}\n.visa-icon .cls-2{\n  fill:#fff;\n}\n\n.visa-icon .cls-3{\n  fill:#ffc107;\n}\n", ""]);
